import {createTheme} from "@mui/material/styles";


export const createAppTheme = (
    primaryColor = "#0f766e",
    accentColor = "#14b8a6",
    companyName = "BusiFarm",
    darkMode = false
) => createTheme({
    palette: {
        mode: darkMode ? 'dark' : 'light',
        primary: {
            main: primaryColor,
        },
        secondary: {
            main: accentColor,
        },
        background: {
            default: darkMode ? '#121212' : '#f5f5f5',
            paper: darkMode ? '#1e1e1e' : '#ffffff',
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    margin: '4px 8px',
                    '&.Mui-selected': {
                        backgroundColor: darkMode
                            ? 'rgba(0, 170, 150, 0.2)'
                            : 'rgba(0, 170, 150, 0.1)',
                        color: primaryColor,
                        '&:hover': {
                            backgroundColor: darkMode
                                ? 'rgba(0, 170, 150, 0.3)'
                                : 'rgba(0, 170, 150, 0.2)',
                        },
                    },
                },
            },
        },
    },
});
